import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Button } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import { withCn } from "../../enhancers/withCn";
export var _ButtonLink = function _ButtonLink(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var handleClick = function handleClick(event) {
    onClick === null || onClick === void 0 || onClick(event);
    if (!event.defaultPrevented) {
      window.location.href = href;
    }
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleClick
  }, restProps, {
    "data-t-id": "common-ButtonLink"
  }));
};
_ButtonLink.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, Button.propTypes), {}, {
  href: PropTypes.string,
  onClick: PropTypes.func
}) : {};
export var ButtonLink = withCn(_ButtonLink);